import { useSingleQueryStep } from '@monorepo/logs/src/contexts/SingleQueryStepContext';
import { ListItemCard } from '@monorepo/shared/componentsV2/ListItemCard';
import { bodyMedium } from '@monorepo/shared/styles/text';
import React, { useMemo } from 'react';
import styled from 'styled-components';

const Subheader = styled.div`
  ${bodyMedium}
  margin-bottom: 0.2rem;
  color: ${({ theme }) => theme.colors.gray333};
`;

const GroupedColumnsPreview = styled(ListItemCard)`
  max-width: 41rem;
  margin-bottom: 1.5rem;
  font-weight: 900;
`;

const ColumnLabel = styled.span`
  color: ${({ theme }) => theme.colors.gray666};
`;

const And = styled.span`
  padding-right: 0.5rem;
  padding-left: 0.5rem;
`;

export function RollingCalculationGrouping() {
  const { availableColumns, groupedColumns } = useSingleQueryStep();
  const groupedColumnLabels: string[] = useMemo(
    () =>
      groupedColumns.map((groupedColumn) => {
        const columnName =
          typeof groupedColumn === 'string'
            ? groupedColumn
            : groupedColumn.parentColumn;
        const column = availableColumns.find(
          (c) => c.columnName === columnName,
        );
        if (!column) {
          throw new Error(
            `Grouped columnName does no present in available fields: ${columnName}`,
          );
        }
        return column.columnLabel;
      }),
    [availableColumns, groupedColumns],
  );
  const content = groupedColumnLabels.map((columnLabel, idx) => (
    <>
      {idx > 0 && <And>and</And>}
      <ColumnLabel>{columnLabel}</ColumnLabel>
    </>
  ));

  if (!groupedColumns.length) {
    return null;
  }

  return (
    <>
      <Subheader>Grouped by</Subheader>
      <GroupedColumnsPreview
        content={content}
        isLocked
        lockedIconTooltip="These fields are defined by an aggregation in a previous Report or Workflow step"
      />
    </>
  );
}
